// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"MultipleTabsAlert_Wrapper__112KE","Message":"MultipleTabsAlert_Message__Iutwd"};